import React from 'react';

import {IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';
import {TaxForecastCommentModal} from 'pages/ais/submit-income-tax-forecast/ui/modal/tax-forecast-comment-modal';
import {TaxForecastEditModal} from 'pages/ais/submit-income-tax-forecast/ui/modal/tax-forecast-edit-modal';

export const taxForecastColumns: IUseCustomTableArgs['columns'] = [
    {
        dataIndex: 'num',
        key: 'num',
        title: '№',
        width: '50px',
        render: (v, row, index) => (
            <TaxForecastEditModal
                forecast={row}
                value={index + 1}
            />
        ),
    },
    {
        dataIndex: 'periodName',
        key: 'periodName',
        title: 'Период',
        width: '150px',
    },
    {
        dataIndex: 'year',
        key: 'year',
        title: 'Год',
        width: '80px',
    },
    {
        dataIndex: 'taxbaseForecast',
        key: 'taxbaseForecast',
        title: 'Прогнозное значение налоговой базы по налогу на прибыль (рублей)',
        children: [
            {
                dataIndex: 'taxbaseForecastFts',
                key: 'taxbaseForecastFts',
                title: 'НО',
                width: '100px',
            },
            {
                dataIndex: 'taxbaseCommentFts',
                key: 'taxbaseCommentFts',
                title: 'Комментарий НО',
                width: '200px',
                render: v => (
                    <TaxForecastCommentModal
                        value={v}
                    />
                ),
            },
            {
                dataIndex: 'taxbaseForecastOrg',
                key: 'taxbaseForecastOrg',
                title: 'НП',
                width: '100px',
            },
            {
                dataIndex: 'taxbaseCommentOrg',
                key: 'taxbaseCommentOrg',
                title: 'Комментарий НП',
                width: '200px',
                render: v => (
                    <TaxForecastCommentModal
                        value={v}
                    />
                ),
            },
        ],
    },
    {
        dataIndex: 'federalTaxForecast',
        key: 'federalTaxForecast',
        title: 'Прогноз суммы налога на прибыль в федеральный бюджет РФ (рублей)',
        children: [
            {
                dataIndex: 'federalTaxForecastFts',
                key: 'federalTaxForecastFts',
                title: 'НО',
                width: '100px',
            },
            {
                dataIndex: 'federalTaxCommentFts',
                key: 'federalTaxCommentFts',
                title: 'Комментарий НО',
                width: '200px',
                render: v => (
                    <TaxForecastCommentModal
                        value={v}
                    />
                ),
            },
            {
                dataIndex: 'federalTaxForecastOrg',
                key: 'federalTaxForecastOrg',
                title: 'НП',
                width: '100px',
            },
            {
                dataIndex: 'federalTaxCommentOrg',
                key: 'federalTaxCommentOrg',
                title: 'Комментарий НП',
                width: '200px',
                render: v => (
                    <TaxForecastCommentModal
                        value={v}
                    />
                ),
            },
        ],
    },
    {
        dataIndex: 'regionalTaxForecast',
        key: 'regionalTaxForecast',
        title: 'Прогноз суммы налога на прибыль в бюджет субъекта РФ (рублей)',
        children: [
            {
                dataIndex: 'regionalTaxForecastFts',
                key: 'regionalTaxForecastFts',
                title: 'НО',
                width: '100px',
            },
            {
                dataIndex: 'regionalTaxCommentFts',
                key: 'regionalTaxCommentFts',
                title: 'Комментарий НО',
                width: '200px',
                render: v => (
                    <TaxForecastCommentModal
                        value={v}
                    />
                ),
            },
            {
                dataIndex: 'regionalTaxForecastOrg',
                key: 'regionalTaxForecastOrg',
                title: 'НП',
                width: '100px',
            },
            {
                dataIndex: 'regionalTaxCommentOrg',
                key: 'regionalTaxCommentOrg',
                title: 'Комментарий НП',
                width: '200px',
                render: v => (
                    <TaxForecastCommentModal
                        value={v}
                    />
                ),
            },
        ],
    },
];
